// Bookings pages that are not ported yet still open on the legacy VTS site.
export const LEGACY_LOGISTICS = 'https://vts.linde.grp/Helium/VTS/Logistics';
export const legacyConfirmCancelUrl = (id: any) => `${LEGACY_LOGISTICS}/Bookings_ConfirmCancel.aspx?BookingID=${id}`;
export const legacyCancelRequestUrl = (id: any) => `${LEGACY_LOGISTICS}/Bookings_CancelRequest.aspx?BookingID=${id}`;
export const legacyPrintUrl = (id: any) => `${LEGACY_LOGISTICS}/Bookings_Print.aspx?BookingID=${id}`;

export const bookingEditPath = (id: any) => `/bookings/edit/${id}`;
